<template>
    <div class="card-header" style="width: 100%;border: solid 1px lightgrey">
      <div v-for="item in dirButtons" :key="item.id" class="dirButtons">
        <FrameButton :key="item.id" :button="item" :parentData="btnParentData"></FrameButton>
      </div>
      <el-icon :size="24" @click="refreshNode(currentDir.id)" style="margin-top: 5px">
        <ElIconRefresh class="el-icon-refresh"/>
      </el-icon>
    </div>

    <el-tree
        ref="tree"
        :data="dirData"
        :props="defaultProps"
        node-key="id"
        :load="loadNode"
        lazy
        @node-click="nodeClickHandle"
        highlight-current
        :expand-on-click-node="false"
        min-height="500px"
        style="height: 100%;overflow: auto"
        >
    </el-tree>
</template>

<script>

export default {
  name: "SysDirManage",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    btnParentData() {
      return {
        dir_def_id: this.parentData.id,
        dir_def_name: this.parentData.name,
        parent_id: this.currentDir.id,
        parent_name: this.currentDir.name
      }
    }
  },
  data() {
    return {
      dirButtons: [
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-folder-add",
          "style": "font-size: 24px",
          "icon_only": true,
          "click": "jsOpenDialog",
          "click_success": [],
          "window": {"component": "frame/FrameForm", "type": "sys_dir_add", "title": "添加子目录", "width": 600, "height": 450}
        },
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-edit",
          "style": "font-size: 24px",
          "icon_only": true,
          "click": "jsOpenDialog",
          "click_success": [],
          "window": {"component": "frame/FrameForm", "type": "sys_dir_edit", "title": "修改目录", "width": 600, "height": 450}
        },
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-TopRight",
          "style": "font-size: 24px",
          "icon_only": true,
          "click": "jsOpenDialog",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "sys_dir_move", "title": "移动目录", "width": 600, "height": 300}
        },
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-delete",
          "icon_only": true,
          "style": "font-size: 24px",
          "click": "jsOpenDialog",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "sys_dir_del", "title": "删除目录", "width": 600, "height": 300}
        },
        {
          "component": "button",
          "text": true,
          "circle": true,
          "icon_only": true,
          "icon": "el-icon-download",
          "style": "font-size: 24px",
          "click": "jsOpenDialog",
          "window": {"component": "frame/FrameForm", "type": "sys_dir_import", "title": "导入目录", "width": 600, "height": 450}
        },
        {
          "component": "button",
          "text": true,
          "circle": true,
          "icon_only": true,
          "icon": "el-icon-upload",
          "style": "font-size: 24px",
          "id":"sys_dir_data_export",
          "click":"export",
          "click_success":[
            "jsExportSuccess"
          ],
          "check_form":true,
          "query_id":"sys_dir_data",
          "span":2,
          "label":"导出"
        }
      ],
      dirData: [],
      currentDir: {},
      editData: {},
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf',
      },
      loading: false
    }
  },
  provide() {
    return {
      $fn: {
        reloadTreeData: () => {
          // 刷新当前节点
          this.refreshNode(this.currentDir.id);
        },
        reloadParentNode: () => {
          //刷新父节点
          console.log("reloadParentNode,parent_id:" + this.currentDir.parent_id)
          this.refreshNode(this.currentDir.parent_id);
        }
      }
    }
  },
  methods: {
    refreshNode(nodeId){
      if(nodeId && nodeId.length > 0){
        this.$refs.tree.store.nodesMap[nodeId].loaded = false;
        this.$refs.tree.store.nodesMap[nodeId].loadData();
      }else{
        this.loadDirTree()
      }
    },
    //--勾选--
    nodeClickHandle(currentRow) {
      this.currentDir = currentRow
    },
    async loadDirTree() {
      let data = await this.$http('sysDirService.getChildren', {dir_def_id: this.parentData.id, parent_id: ''})
      this.dirData = data;
    },
    async loadNode(node, resolve) {
      console.log("node.id=" + node.data.id);
      var params = {
        parent_id: node.data.id,
        dir_def_id: this.parentData.id
      }
      let data = await this.$http('sysDirService.getChildren', params)
      resolve(data)
    }
  },
  created() {

  }
}
</script>


<style lang="less" scoped>
@import '@/global.less';

.myContainer {
  padding: 5px;
}

.dirButtons {
  display: inline-flex;
}

.card-header {
  display: inline-flex;
  height: 36px;
}

.department-name {
  font-size: @fontSizeX;
}


.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.doc-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  min-height: 600px;
}

.doc-card {
  width: 150px;
  height: 210px;
  margin: 10px;
  border: 1px solid gainsboro;
  border-radius: 10px;
}

.doc-card:hover {
  background-color: #E5F3FF;
}

.file-count {
  color: #409EFF;
  font-size: large;
  margin-left: 5px;
}

.pdf {
  background-image: url("../../../../public/icon/filetype/pdf.png");
}

.excel {
  background-image: url("../../../../public/icon/filetype/excel.png");
}

.word {
  background-image: url("../../../../public/icon/filetype/word.png");
}

.ppt {
  background-image: url("../../../../public/icon/filetype/ppt.png");
}

.png {
  background-image: url("../../../../public/icon/filetype/jpg.png");
}

.file {
  background-image: url("../../../../public/icon/filetype/file.png");
}

.icon {
  width: 100px;
  height: 100px;
  background-size: 100px 100px;
  margin-left: 25px;
}

.doc-name {
  font-size: 16px;
  width: 100%;
  height: 33px;
  margin-top: 10px;
  margin-bottom: 10px;
  //word-wrap: normal;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  line-height: 16px;
  padding-left: 10px;
  text-align: center;
}

.doc-version {
  margin-left: 10px;
  font-size: 20px;
  width: 100%;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.doc-author {
  font-size: 16px;
  width: 100%;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.doc-time {
  font-size: 14px;
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
}

.doc-status {
  font-size: 12px;
  width: 100%;
}

.doc-menu {
  font-size: 14px;
  margin: 5px 0 0 5px;
}

.departmentBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.departmentLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.departmentRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.departmentUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}

.departmentTitle {
  height: 45px !important;
  line-height: 40px;
  font-size: @fontSizeSS;
}

.departmentName {
  white-space: nowrap;
  min-width: 120px;
  margin-right: 30px;
  padding-right: 20px;
  font-size: @fontSizeS;
}

.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.departmentEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.departmentTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDepartment {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.editButton {
  color: lightgrey;
  min-height: 30px;
  padding: 0;
}

.editButton:hover {
  color: #00afff;
}

</style>
